import _ from 'underscore';
export default (url, slideIndex) => {
    const slide = (slideIndex + 1);
    let urlSplit = url.split('/');
    urlSplit = _.compact(urlSplit);
    let isNan = Number(urlSplit[urlSplit.length - 1]);
    isNan = _.isNaN(isNan);
    if (isNan) {
        urlSplit.push(slide);
        return urlSplit.join('/');
    }
    // if slide index is a negative number then that
    // is a flag to return a url sans slide index
    if (slide <= 0) {
        urlSplit.pop();
        return urlSplit.join('/');
    }
    urlSplit[urlSplit.length - 1] = slide;
    return urlSplit.join('/');
};
